<template>
  <div class="modal" v-bind:style="{ height: innerHeight + 'px' }">
    <div
      v-bind:style="{ maxHeight: modalHeight + 'px' }"
      class="modal-box"
      :class="[type === 'country' ? 'links-modal-box' : 'welcome-modal-box']"
    >
      <img v-if="type === 'welcome'" class="modal--icon" src="../assets/icon.svg" alt="Copa Modal Logo" />
      <div v-bind:style="{ maxHeight: modalInnerHeight + 'px' }" class="modal-box-contents">
        <img @click="triggerModalClose" class="modal--close" src="../assets/close.png" alt="Close Modal Icon" />
        <country v-if="type === 'country'" :info="info" />
        <welcome @closeTutorial="triggerModalClose" v-if="type === 'welcome'" />
      </div>
    </div>
  </div>
</template>
<script>
import Country from "./Country";
import Welcome from "./Welcome";
export default {
  props: {
    info: Object,
    type: String
  },
  name: "modal",
  data() {
    return {
      articles: this.info,
      innerHeight: undefined,
      modalHeight: undefined,
      modalInnerHeight: undefined
    };
  },
  mounted() {
    this.setModalHeight();
    this.$nextTick(function() {
      window.addEventListener("resize", this.setModalHeight);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setModalHeight);
  },
  computed: {},
  components: {
    country: Country,
    welcome: Welcome
  },
  methods: {
    triggerModalClose: function() {
      this.$emit("close");
    },
    setModalHeight() {
      console.log("window", window);
      this.innerHeight = window.innerHeight;
      if (window.innerHeight < 800) {
        this.modalHeight = window.innerHeight - 20;
        this.modalInnerHeight = window.innerHeight - 70;
      } else {
        this.modalHeight = (window.innerHeight / 100) * 90;
        this.modalInnerHeight = (window.innerHeight / 100) * 85;
      }
    }
  }
};
</script>

<style lang="scss">
@import "../style/components/modal";
</style>
